export default __webpack_public_path__ + "static/ben-marrel-1fc1c8bfec3d81b698317c40bb106772.jpeg";